'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _rentalCheckout = require('./rental-checkout');

var _rentalCheckoutStepOne = require('./rental-checkout-step-one');

var _rentalCheckoutStepTwo = require('./rental-checkout-step-two');

var _rentalCheckoutStepThree = require('./rental-checkout-step-three');

var _rentalCheckoutProductInfo = require('./components/rental-checkout-product-info');

var _rentalCheckoutDeliveryInfo = require('./components/rental-checkout-delivery-info');

var _rentalProductGrid = require('./components/rental-product-grid');

var _rentalProductGridItem = require('./components/rental-product-grid-item');

var _rentalProductTable = require('./components/rental-product-table');

var _rentalWizard = require('./components/rental-checkout-wizard/rental-wizard');

var _rentalWizardMenu = require('./components/rental-checkout-wizard/rental-wizard-menu');

var _rentalWizardStep = require('./components/rental-checkout-wizard/rental-wizard-step');

var _rentalWizardButton = require('./components/rental-checkout-wizard/rental-wizard-button');

var _rentProductOverviewGrid = require('./components/rent-product-overview-grid');

var _rentProductOverviewGridItem = require('./components/rent-product-overview-grid-item');

var _rentProductImg = require('./components/rent-product-img');

require('angular-messages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.rental', ['ngMessages']);

_module.config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('rentalCheckout', {
        parent: 'seller.rentProductDetail',
        url: '/rentalCheckout',
        views: {
            'main@root': {
                component: 'rentalCheckout'
            },
            'header@root': '',
            'aside@root': '',
            'menu@root': ''
        },
        resolve: {
            rentalProduct: ["rentalProductsService", "$stateParams", function rentalProduct(rentalProductsService, $stateParams) {
                return rentalProductsService.getRentalProductById($stateParams.productId).then(function (rentalProduct) {
                    return rentalProduct;
                });
            }],
            wizardMenuSteps: ["Enums", "gettextCatalog", function wizardMenuSteps(Enums, gettextCatalog) {
                var menu = JSON.parse(JSON.stringify(Enums.rentalCheckoutMenuSteps));
                return menu.map(function (obj) {
                    obj.value = gettextCatalog.getString(obj.value);
                    return obj;
                });
            }],
            deliveryInfo: ["DeliveryInfoRentalProduct", function deliveryInfo(DeliveryInfoRentalProduct) {
                return DeliveryInfoRentalProduct.create({});
            }],
            contactInfo: ["ContactInfoRentalProduct", function contactInfo(ContactInfoRentalProduct) {
                return ContactInfoRentalProduct.create({});
            }],
            rentedProductsOrder: ["RentalProductsOrder", function rentedProductsOrder(RentalProductsOrder) {
                return RentalProductsOrder.create({});
            }]
        },
        params: {
            productId: {
                value: null,
                squash: true
            },
            sellerId: {
                value: null,
                squash: true
            }
        },
        data: {
            febelcoCustomer: true
        },
        ncyBreadcrumb: {
            label: '{{"Uw huuraanvraag" | translate }}'
        }
    });
}]);

_module.component('rentalCheckout', _rentalCheckout.rentalCheckoutComponent).component('rentalCheckoutStepOne', _rentalCheckoutStepOne.rentalCheckoutStepOneComponent).component('rentalCheckoutStepTwo', _rentalCheckoutStepTwo.rentalCheckoutStepTwoComponent).component('rentalCheckoutStepThree', _rentalCheckoutStepThree.rentalCheckoutStepThreeComponent).component('rentalCheckoutProductInfo', _rentalCheckoutProductInfo.rentalCheckoutProductInfoComponent).component('rentalCheckoutDeliveryInfo', _rentalCheckoutDeliveryInfo.rentalCheckoutDeliveryInfoComponent).component('rentalProductGrid', _rentalProductGrid.rentalProductGridComponent).component('rentalProductGridItem', _rentalProductGridItem.rentalProductGridItemComponent).component('rentalProductTable', _rentalProductTable.rentalProductTableComponent).component('rentalWizard', _rentalWizard.rentalWizardComponent).component('rentalWizardStep', _rentalWizardStep.rentalWizardStepComponent).component('rentalWizardMenu', _rentalWizardMenu.rentalWizardMenuComponent).component('rentProductOverviewGrid', _rentProductOverviewGrid.rentProductOverviewGridComponent).component('rentProductOverviewGridItem', _rentProductOverviewGridItem.rentProductOverviewGridItemComponent).component('rentProductImg', _rentProductImg.rentProductImageComponent).directive('wzNext', _rentalWizardButton.rentalWizardButton).directive('wzPrevious', _rentalWizardButton.rentalWizardButton).directive('wzFinish', _rentalWizardButton.rentalWizardButton).directive('wzCancel', _rentalWizardButton.rentalWizardButton);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/rental/index.js
// module id = 999
// module chunks = 0